import { createButtonStore } from '@/components/OfferButton/store'

export const createDiscountModalStore = createButtonStore('discount_modal')

export const useDiscountModalStore = () => createDiscountModalStore()
